import { BaseSong } from 'services/api/entities';
import { getWaveformData } from 'services/helpers/song';
import { Song } from '../songs/types';

export async function fetchAndCombineSongsData(
  songs: BaseSong[]
): Promise<Record<string, Song>> {
  const songDataPromises = songs.map(async (song) => {
    const peaks = await getWaveformData(song);
    const newSong = { ...song, peaks };
    return [song.id, newSong];
  });

  const songDataArray = await Promise.all(songDataPromises);
  return Object.fromEntries(songDataArray);
}
